import React, { useState, useEffect } from "react";
import { PaymentRequestButtonElement, useStripe, useElements } from '@stripe/react-stripe-js';
import SmallScreenView from "../../components/smallscreen";
import { Hidden } from "react-awesome-styled-grid";
import { AmountDivideByHundred } from "../../helper";
import {
    FlexContainer,
    H1Text,
} from "../../design";
import PaymentError from "../paymenterror";

type Props = {
    payment: Object;
    chargeByApplePay: Function;
};

const ApplePay = (props: Props) => {
    const stripe = useStripe();
    const elements = useElements();
    const [paymentRequest, setPaymentRequest] = useState(null);
    const { payment, chargeByApplePay } = props;


    useEffect(() => {
        if (!stripe || !elements) {
            return;
        }
        const pr = stripe.paymentRequest({
            country: (payment && payment.currency) ? payment.currency.countryAlpha2 : 'US',
            currency: (payment && payment.currency) ? (payment.currency.name === 'USD' ? 'usd' : 'inr') : 'usd',
            total: {
              label: 'Apple pay',
              amount: (payment && payment.amount) ? payment.amount : 0,
            },
            requestPayerName: true,
            requestPayerEmail: true,
          });

          pr.canMakePayment().then((result) => {
            if (result) {
              setPaymentRequest(pr);
            }
          });

        pr.on('paymentmethod', async (e) => {
            const value = await chargeByApplePay(e.paymentMethod);
            if (value) {
                e.complete('fail');
            }
            e.complete('success');
        });
    }, [stripe, elements, payment]);

    return (
        <>
            <FlexContainer
                flexDirection="column"
            >
                <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                    <div className="row m-0">
                     {
                         paymentRequest && (
                            <PaymentRequestButtonElement options={{paymentRequest}} />
                         )
                     }   
                    </div>
                </div>
            </FlexContainer>
        </>
    )
}

export default ApplePay;